import React from 'react';
import keycloak from '../keyCloak'; // adjust path if needed
import { FaUser } from "react-icons/fa";

const FirstNameDisplay = () => {
  if (!keycloak.authenticated) return null;

  const firstName = keycloak.tokenParsed?.given_name || 'User';

  return <span style={{ borderRight: 'solid 0.2rem #057fa2', backgroundColor: '#057fa2', paddingRight: '1rem' , color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}><FaUser /> <p>{firstName}</p></span>;
}

export default FirstNameDisplay;